<div class="box-border w-26 min-h-26 py-2 pb-3 flex-col text-center rounded-2xl border border-black">
 <div class="py-4 px-6">
   <mat-icon [svgIcon]="icon"></mat-icon>
 </div>
  <div class="text-md text-gray-600">{{label}}</div>
  <div class="font-bold">{{value}} {{currency}}</div>
</div>
